import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { useAccounts } from '../../context/AccountContext';

export default function CopiedTrades() {
  const { scopeParams } = useAccounts();
  const [execs, setExecs]   = useState([]);
  const [total, setTotal]   = useState(0);
  const [page, setPage]     = useState(1);
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = { page, limit: 50, ...scopeParams };
    if (status) params.status = status;
    api.get('/copier/copy-history', { params })
      .then(r => { setExecs(r.data.executions); setTotal(r.data.total); })
      .finally(() => setLoading(false));
  }, [page, status, scopeParams]);

  return (
    <div className="row">
      <div className="col-12">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h5 className="card-title mb-0">Copied Trades History ({total})</h5>
            <select className="form-control form-control-sm" style={{ width: 150 }}
              value={status} onChange={e => { setStatus(e.target.value); setPage(1); }}>
              <option value="">All Status</option>
              <option value="executed">Executed</option>
              <option value="failed">Failed</option>
              <option value="skipped">Skipped</option>
              <option value="closed">Closed</option>
            </select>
          </div>
          <div className="card-body">
            {loading ? <p className="text-muted">Loading...</p> : (
              <>
                <div className="table-responsive table-cards table-cards-wrap">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Time</th>
                        <th>Trader</th>
                        <th>Symbol</th>
                        <th>Type</th>
                        <th className="num">Orig Lots</th>
                        <th className="num">Copied Lots</th>
                        <th className="num">Scaling Factor</th>
                        <th className="num">Copier Ticket</th>
                        <th className="num">P&L</th>
                        <th>Status</th>
                        <th>Note</th>
                      </tr>
                    </thead>
                    <tbody>
                      {execs.map(e => (
                        <tr key={e._id}>
                          <td data-label="Time" className="text-muted small">{new Date(e.createdAt).toLocaleString()}</td>
                          <td data-label="Trader" className="small">{e.traderId?.email || '—'}</td>
                          <td data-label="Symbol"><strong>{e.originalTradeId?.symbol || '—'}</strong></td>
                          <td data-label="Type">
                            {e.originalTradeId?.type && (
                              <span className={`badge badge-${e.originalTradeId.type === 'buy' ? 'success' : 'danger'}`}>
                                {e.originalTradeId.type.toUpperCase()}
                              </span>
                            )}
                          </td>
                          <td data-label="Orig Lots" className="num">{e.originalTradeId?.lots}</td>
                          <td data-label="Copied Lots" className="num">{e.scaledLots}</td>
                          <td data-label="Scaling Factor" className="num">{e.scalingFactor ? `${(e.scalingFactor * 100).toFixed(0)}%` : '—'}</td>
                          <td data-label="Copier Ticket" className="num small">{e.copierTicket || '—'}</td>
                          <td data-label="P&L" className={`num ${e.profit >= 0 ? 'text-success' : 'text-danger'}`}>
                            {e.profit !== undefined && e.profit !== null
                              ? `${e.profit >= 0 ? '+' : ''}${e.profit?.toFixed(2)}`
                              : '—'}
                          </td>
                          <td data-label="Status">
                            <span className={`badge badge-${
                              e.status === 'executed' || e.status === 'closed' ? 'success'
                              : e.status === 'failed' ? 'danger'
                              : e.status === 'skipped' ? 'warning'
                              : 'secondary'
                            }`}>{e.status}</span>
                          </td>
                          <td data-label="Note" className="text-muted small">{e.failReason || ''}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="d-flex justify-content-between mt-2">
                  <span className="text-muted small">Page {page} — {execs.length} / {total}</span>
                  <div>
                    <button className="btn btn-sm btn-secondary mr-1" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>Prev</button>
                    <button className="btn btn-sm btn-secondary" disabled={execs.length < 50} onClick={() => setPage(p => p + 1)}>Next</button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
